import { atom } from 'jotai';
import { Nullable, Section } from '@/types/generic';

export const sectionAtom = atom<Nullable<Section>>(null);
